import {useMemo} from 'react'

import {CalculatedBookingPriceObject} from '../../api/booking/calculate-booking-price'
import {mergeApplicable} from '../../api/promo-codes/card-state'
import {sumPromoDiscount} from '../../api/promo-codes/helpers'
import {useFormikPromoCode} from '../../components/promo-code-field/use-formik-promo-code'
import {safeRound} from '../../helpers/logic'

export const useServicePromo = ({
  data,
  isFetching,
  quotedAt,
  serviceId,
  enabled = true,
}: {
  data?: CalculatedBookingPriceObject[]
  isFetching: boolean
  quotedAt: number
  serviceId?: string | null
  enabled?: boolean
}) => {
  const promoApplied = data?.[0]?.promoApplied ?? null
  const promoError = promoApplied ? null : data?.[0]?.promoError ?? null
  const promoDiscount = safeRound(sumPromoDiscount(data))
  const total = data ? data.reduce((acc, el) => acc + Number(el.price), 0) : 0
  const formik = useFormikPromoCode({
    promoApplied,
    promoError,
    // Two sections quote on the payment page; only the one showing the field judges the code.
    isQuoting: isFetching || !enabled,
    quotedAt,
  })
  const items = useMemo(
    () => (serviceId ? [{entityType: 'service' as const, entityId: serviceId}] : []),
    [serviceId],
  )
  return {
    fieldProps: {
      ...formik,
      items,
      applied: promoApplied,
      applicable: data ? mergeApplicable(data.map((el) => el.applicableCopies)) : undefined,
      isQuoting: isFetching,
      hidden: !data || total === 0,
    },
    pricingPromo: promoApplied && promoDiscount > 0 ? {code: promoApplied.code, amount: promoDiscount} : null,
  }
}
